// @ts-strict-ignore
import React, { useState, useCallback } from 'react';
import { selectPreviewWorkflowRoutingAction } from 'flow/store/redux/selectors';
import { Button, ButtonVariant, IconName } from '@usealloy/component-library';
import { useAppDispatch, useAppSelector } from '~/store/reduxHooks';
import IslandActionRuleEditor from '../../IslandActionRuleEditor';
import type { BaseWorkflowRoutingIslandProps } from '../types';
import { ActionType } from '~/dashboard/views/workflows/store/engine/constants';
import BaseComplexIsland from '../../BaseComplexIsland';
import type { Action } from '~/dashboard/views/workflows/store/engine/types';
import { removeAction, resetNodeAndConnectorState } from '~/dashboard/views/workflows/store/redux/slice';
import { generatePublicId } from '~/dashboard/views/workflows/store/engine/utils';
import * as helpers from './helpers';


interface ComplexWorkflowRoutingIslandProps extends BaseWorkflowRoutingIslandProps { }

export default function ComplexWorkflowRoutingIsland({
  workflowRoutingActions,
}: ComplexWorkflowRoutingIslandProps) {
  const dispatch = useAppDispatch();
  const previewWorkflowRoutingAction = useAppSelector(selectPreviewWorkflowRoutingAction);

  const [
    isAddingNewWorkflowRoutingAction, setIsAddingNewWorkflowRoutingAction,
  ] = useState(Boolean(previewWorkflowRoutingAction));

  const [
    previewWorkflowRoutingActionPublicId, setPreviewWorkflowRoutingActionPublicId,
  ] = useState<Action['publicId']>(previewWorkflowRoutingAction?.publicId ?? null);

  const handleDrawerToggle = useCallback(() => {
    if (previewWorkflowRoutingAction) {
      dispatch(removeAction({ id: previewWorkflowRoutingAction.publicId }));
    }

    dispatch(resetNodeAndConnectorState());
  }, [dispatch, previewWorkflowRoutingAction]);


  const handleOnAddWorkflowRoutingClick = useCallback(() => {
    const publicId = generatePublicId('action', ActionType.WORKFLOW);
    helpers.handleOnAddWorkflowRoutingClick(
      dispatch,
      workflowRoutingActions,
      publicId,
    );

    setIsAddingNewWorkflowRoutingAction(true);
    setPreviewWorkflowRoutingActionPublicId(publicId);
  }, [dispatch, workflowRoutingActions]);

  const handleOnSubmitAction = useCallback(() => {
    setIsAddingNewWorkflowRoutingAction(false);
    setPreviewWorkflowRoutingActionPublicId(null);
  }, []);

  const handleOnCancelAction = useCallback(() => {
    setIsAddingNewWorkflowRoutingAction(false);
  }, []);

  return (
    <BaseComplexIsland
      onDrawerToggle={handleDrawerToggle}
      title="Workflow Routing"
    >
      <Button
        disabled={isAddingNewWorkflowRoutingAction}
        icon={IconName.Add}
        onClick={handleOnAddWorkflowRoutingClick}
        variant={ButtonVariant.tertiary}
      >
        Add Workflow
      </Button>

      {workflowRoutingActions.map(workflowRoutingAction => (
        <IslandActionRuleEditor
          key={workflowRoutingAction.publicId}
          action={workflowRoutingAction}
          actionType={ActionType.WORKFLOW}
          allActionsOfActionType={workflowRoutingActions}
          isPreviewAction={workflowRoutingAction.publicId === previewWorkflowRoutingActionPublicId}
          onCancelAction={handleOnCancelAction}
          onSubmitAction={handleOnSubmitAction}
        />
      ))}


    </BaseComplexIsland>


  );
}
